import { Card, Flex, Grid, Text, type IconName, USP } from "@huub-web/ui";
import type { ReactNode, FC, Ref } from "react";

import { uspsStyle } from "./ViewingTipsCard.css";

export type ViewingTipsCardProps = {
  cta?: ReactNode;
  title?: string;
  subtitle?: string;
  tips?: {
    title: string;
    body: string;
    icon: IconName;
  }[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const ViewingTipsCard: FC<ViewingTipsCardProps> = ({
  title = "Bereid je voor op de bezichtiging",
  subtitle = "Ontvang een handige checklist met gerichte tips om tijdens de bezichtiging niets te missen — van de staat van de woning tot de omgeving.",
  tips = [
    {
      title: "Let op geluidsoverdracht",
      body: "Klop zachtjes op muren, vloeren of plafonds om te horen of ze massief of hol klinken.",
      icon: "sound",
    },
    {
      title: "Let op de stand van de zon",
      body: "Kijk of de zon op de gewenste tijden binnenkomt en of de indeling praktisch is voor jouw leefstijl.",
      icon: "sunPositionFilled",
    },
    {
      title: "Let op vochtproblemen",
      body: "Kijk of er vochtproblemen zijn zoals condens op ramen, vochtplekken of schimmel.",
      icon: "dropFilled",
    },
  ],
  cta,
  ref,
}) => (
  <Card ref={ref} variant="infoSurface" padding="xl">
    <Grid variant="twoColumnMarketing">
      <Flex direction="column" gap="l" align="flex-start">
        <Text as="h2" variant="displayL" bold>
          {title}
        </Text>
        <Text as="p" variant="bodyM" color="currentColor50">
          {subtitle}
        </Text>
        {cta}
      </Flex>
      <Flex direction="column" className={uspsStyle}>
        {tips.map((tip, index) => (
          <USP
            key={`${tip.title}-${index}`}
            size="m"
            variant="primary"
            icon={tip.icon}
            title={tip.title}
            body={tip.body}
          />
        ))}
      </Flex>
    </Grid>
  </Card>
);
